import { Court } from "@app/core/court/domain/model/court";

export class CourtMapper {
  static deserialize(data: any): Court {
    return new Court(data.id_court, data.name_court, data.integrated);
  }
}
